export const NON_FIELD_ERRORS_KEY = "non_field_errors";
export const CSRF_COOKIE_NAME = import.meta.env.VITE_CSRF_COOKIE_NAME;
export const HTML5_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const INCOMPLETE_FORM_MESSAGE = "Sorry, not all fields are filled out correctly.";
